import {Injectable} from "@angular/core";
import {Environment} from "./environment-core";

@Injectable()
export class UrlsResources {

  private serverUrl;

  constructor(private environment: Environment) {
    this.serverUrl = environment.api;
  }

  getSignInUrl() {
    return `${this.serverUrl}/adminportal/auth/oauth/token`;
  }

  getPayments(): string {
    return `${this.serverUrl}/lotto/adminportal/pronosticos/`;
  }

  doElectronicPayout(): string {
    return `${this.serverUrl}/lotto/private/transfers`;
  }

  getPrivateRoot(): string {
    return `${this.serverUrl}/lotto/private`;
  }

  doElectronicTransferToUsers(): string {
    return `${this.serverUrl}/lotto/private/customers/transfers`;
  }

  doPayout(): string {
    return `${this.serverUrl}/lotto/adminportal/pronosticos/payout`;
  }

  doPayout2Account(): string {
    return `${this.serverUrl}/lotto/adminportal/pronosticos/award/payout`;
  }

  getRefreshTokenUrl() {
    return `${this.serverUrl}/adminportal/auth/oauth/token`;
  }

  getCahngePasswordUrl() {
    return `${this.serverUrl}/adminportal/admin/updateCurrentPassword`;
  }

  getConciliacionUrl() {
    return `${this.serverUrl}/adminportal/admin/conciliacion`;
  }

  getConciliacionCsvUrl() {
    return `${this.serverUrl}/adminportal/admin/conciliacion/csv/game`;
  }

  getBlnkTransactionReportUrl() {
    return `${this.serverUrl}/adminportal/admin/blnk/reports/transactions`;
  }

  getConciliacionDashboardUrl() {
    return `${this.serverUrl}/adminportal/admin/conciliacion/dashboard`;
  }

  getConciliacionErrorDashboardUrl() {
    return `${this.serverUrl}/adminportal/admin/conciliacion/dashboard/error`;
  }

  getConciliacionCancelacionDashboardUrl() {
    return `${this.serverUrl}/adminportal/admin/conciliacion/dashboard/cancelaciones`;
  }

  getConciliacionDashboardGamesUrl() {
    return `${this.serverUrl}/adminportal/admin/conciliacion/dashboard/games`;
  }

  getUsuariosPPAPUrl() {
    return `${this.serverUrl}/adminportal/admin/usuarios/ppap`;
  }

  getRegisterRolesUrl() {
    return `${this.serverUrl}/adminportal/admin/register/roles`;
  }

  getTrustedRegistrationDomains() {
    return `${this.serverUrl}/adminportal/admin/trusted-registration-domains`;
  }

  getRegisterUsuariosPPAPUrl() {
    return `${this.serverUrl}/ppap/lotto/private/pronosticos/members`;
  }


  getGameInfo(game) {
    // return `${this.serverUrl}lotto/public/pronosticos/melate/info`;
    return this.serverUrl + '/lotto/public/pronosticos/' + game + '/info';
  }

  setGameInfo(game) {
    return `${this.serverUrl}/lotto/public/pronosticos/${game}/info`;
  }

  getGameInfoTris() {
    // return `${this.serverUrl}lotto/public/pronosticos/melate/info`;
    return this.serverUrl + '/lotto/public/pronosticos/tris/info';
  }

  getDrawDefForGame(game) {
    return this.serverUrl + '/lotto/public/pronosticos/' + game + '/drawDef';
  }

  setDrawDefinitionForGame(game) {
    return `${this.serverUrl}/lotto/public/pronosticos/${game}/drawDef`;
  }

  getBusinessRules(id): string {
    return this.serverUrl + '/lotto/public/pronosticos/business/rules/' + id;
  }

  patchBusinessRules(id): string {
    return this.serverUrl + '/lotto/adminportal/pronosticos/business/rules/' + id;
  }

  getActiveFootballPools(game): string {
    return this.serverUrl + '/lotto/public/pronosticos/' + game + '/active/pools';
  }

  updateFootballTeams(game): string {
    return this.serverUrl + '/lotto/adminportal/pronosticos/' + game + '/teams';
  }

  sendProgolPeriods(game: string): string {
    return this.serverUrl + '/lotto/adminportal/pronosticos/' + game + '/periods';
  }

  getPaymentsDashboard(): string {
    return this.serverUrl + '/lotto/adminportal/pronosticos/dashboard/payments';
  }

  customerUrl(): string {
    return this.serverUrl + '/lotto/private/customers';
  }

  getSalesDashboard(): string {
    return this.serverUrl + '/lotto/adminportal/dashboard/sales';
  }

  getGanalottodoUsersDashboard(): string {
    return this.serverUrl + '/lotto/adminportal/dashboard/ganalottodo-users';
  }

  getPromociones(promotionType: string): string {
    return this.serverUrl + '/adminportal/admin/promotions/' + promotionType;
  }

  uploadCodesPromotions(): string {
    return this.serverUrl + '/adminportal/admin/promotion/uploadCodes';
  }

  generateAndAddCodesPromotionsUrl(): string {
    return this.serverUrl + '/adminportal/admin/promotion/addCodes';
  }

  getPromocionesChangeStatus(): string {
    return this.serverUrl + `/adminportal/admin/promotions/changestatus`;
  }

  persistPromotion(): string {
    return this.serverUrl + '/lotto/adminportal/promotion';
  }

  getPromocionesChangePrincipal(): string {
    return this.serverUrl + `/adminportal/admin/promotions/changeprincipal`;
  }

  getErrorCodesCsv(promotionKey): string {
    return this.serverUrl + `/adminportal/admin/promotions/${promotionKey}/codes/error`;
  }

  getDefaultPromotion(): string {
    return this.serverUrl + '/lotto/public/promotion/default';
  }

  getPromotionTypeList(isGanalottodo: boolean): string {
    return this.serverUrl + '/lotto/adminportal/promotions/type/' + isGanalottodo;
  }

  getPromotionByKey(key: string): string {
    return this.serverUrl + '/lotto/adminportal/promotion/' + key;
  }

  getPromotionDetail(promotionKey: String) {
    return this.serverUrl + `/adminportal/admin/promotions/${promotionKey}/users`;
  }

  resendEmailPromotionUrl() {
    return this.serverUrl + `/adminportal/admin/promotions/resend-email`;
  }

  retryPromotionUrl() {
    return this.serverUrl + `/adminportal/admin/promotions/retry-promotion`;
  }

  getUrls() {
    return this.serverUrl + `/adminportal/admin/referrals/ursl`;
  }

  getRefersUrl() {
    return this.serverUrl + '/adminportal/admin/referrals';
  }

  saveReferral() {
    return this.serverUrl + `/adminportal/admin/referral`;
  }

  changeStatusReferUrl() {
    return this.serverUrl + '/adminportal/admin/referrals/changestatus';
  }

  getReferByKey(key: string) {
    return this.serverUrl + '/adminportal/admin/referral/' + key;
  }

  getAdminUsernames(): string {
    return this.serverUrl + '/adminportal/admin/admin-usernames';
  }

  getMessagesOfBannerUrl(): string {
    return this.serverUrl + '/adminportal/admin/banner/messages';
  }

  getMessagesOfBannerByMessageKeyUrl(messageKey): string {
    return this.serverUrl + '/adminportal/admin/banner/messages/' + messageKey;
  }

  saveMessageOfBannerUrl(): string {
    return this.serverUrl + '/adminportal/admin/banner/messages';
  }

  updateMessageOfBannerUrl(messageKey): string {
    return this.serverUrl + '/adminportal/admin/banner/messages/' + messageKey;
  }

  changeStatusMessageUrl(messageKey) {
    return this.serverUrl + '/adminportal/admin/banner/messages/active/' + messageKey;
  }

  deleteMessageUrl(messageKey) {
    return this.serverUrl + '/adminportal/admin/banner/messages/' + messageKey;
  }

  countUsersByCriterias() {
    return this.serverUrl + '/adminportal/admin/customers/count';
  }

  enrollCustomersByCriterias() {
    return this.serverUrl + '/adminportal/admin/promotion/enroll/customers';
  }

  activedPromotionsUrl() {
    return this.serverUrl + '/adminportal/admin/promotions/ganalottodo';
  }

  advanceUsersDownloadCsv() {
    return this.serverUrl + '/adminportal/admin/reports/codePromotion';
  }

  promotionTriggers() {
    return this.serverUrl + '/adminportal/admin/promotions/triggers';
  }

  getLimitPurchaseUserWhiteListUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/rules/limit/purchase';
  }

  updateLimitPurchaseUserWhiteListUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/rules/limit/purchase/update';
  }

  glottoCustomersUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/customers';
  }

  glottoCustomerUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/customer';
  }

  glottoRiskPreventionUpdateCustomerUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/customer';
  }

  glottoCustomerTransactionsUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/customer/transactions';
  }

  megamillionsRulesUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/megamillions/rules';
  }

  addWinnerUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/winners';
  }

  availabelGamesUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/games';
  }

  getGamesForPromotionUrl() {
    return this.serverUrl + '/adminportal/admin/promotion/config/games';
  }

  uploadAwardsUrl(): string {
    return this.serverUrl + '/adminportal/admin/ganalottodo/pppawinners/uploadawards';
  }

  awardsUploadedUrl() {
    return this.serverUrl + '/adminportal/admin/ganalottodo/pppawinners';
  }

  deleteCustomerUrl(username: string) {
    return this.serverUrl + '/adminportal/admin/customers/' + encodeURIComponent(username) + '/delete';
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/urls-resources.ts